import { createSlice } from '@reduxjs/toolkit';

const certificationSlice = createSlice({
  name: 'certification',
  initialState: {
    // enrollmentMap: { [certificationId]: { status, applicationId } }
    // Populated when the list is fetched or after enroll/start actions.
    enrollmentMap: {},
  },
  reducers: {
    setEnrollmentMap: (state, action) => {
      // action.payload: array of CertificationSummary from GET /api/UserCertification
      // Build the map from the list response so every card has the latest status.
      const map = {};
      action.payload.forEach((cert) => {
        if (cert.userEnrollmentStatus !== null && cert.userEnrollmentStatus !== undefined) {
          map[cert.certificationId] = {
            status: cert.userEnrollmentStatus,
            applicationId: cert.applicationId ?? null,
          };
        }
      });
      state.enrollmentMap = map;
    },
    setEnrollment: (state, action) => {
      // action.payload: { certificationId, status, applicationId }
      const { certificationId, status, applicationId } = action.payload;
      state.enrollmentMap[certificationId] = { status, applicationId: applicationId ?? null };
    },
    clearEnrollment: (state, action) => {
      // action.payload: certificationId
      delete state.enrollmentMap[action.payload];
    },
    clearAllEnrollments: (state) => {
      state.enrollmentMap = {};
    },
  },
});

export const {
  setEnrollmentMap,
  setEnrollment,
  clearEnrollment,
  clearAllEnrollments,
} = certificationSlice.actions;

export default certificationSlice.reducer;
